module.exports = __webpack_public_path__ + "components/flag/static/square/sk-ddb8b25f1d7c32593c7e9cc62d40b3c6.svg";